'use client';

import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import SignpostFilled from '@alltrails/denali/icons/SignpostFilled';
import { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { tmbSlug } from '@/utils/tourDuMontBlanc';

type TmbBadgeProps = {
  languageRegionCode: LanguageRegionCode;
};

const TmbBadge = ({ languageRegionCode }: TmbBadgeProps) => {
  return (
    <StatusBadge
      icon={{ Component: SignpostFilled }}
      linkInfo={{ href: wrapUrlSafe(`/${tmbSlug}`, languageRegionCode), target: '_blank' }}
      size="sm"
      text="Tour du Mont Blanc"
      treatment="strong"
      variant="positive"
    />
  );
};

export default TmbBadge;
